module.exports = __webpack_public_path__ + "77ff1161585d39dfbcfb023f44b8ad1f.png";